import { z } from "zod";

export const settingsFormSchema = z.object({
  prefillPersonalInfo: z.boolean(),
  prefillBankingInfo: z.boolean(),
  autoSaveProgress: z.boolean(),
  emailNotifications: z.boolean(),
});

export type SettingsFormValues = z.infer<typeof settingsFormSchema>;